import React, { Component } from 'react';
import { connect } from 'react-redux';

import PorCarouselItem from './por-carousel-item';
import CarouselRender from './carousel-render';

import './style.css';

class InactivePorCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  renderItems = () => {
    this.setState({
      data: this.props.inactivePorDeals.map(deal =>
        PorCarouselItem({
          image: deal.attributes.image,
          porDeal: deal.attributes['por-deal-percentage']
            ? `${deal.attributes['por-deal-percentage']}%`
            : `£${Number(deal.attributes['por-deal-monetary']).toFixed(2)}`,
          wholesalerGroup: deal.attributes['wholesaler-subgroup-name'],
          endDate: deal.attributes['end-date']
        }))
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.inactivePorDeals !== this.props.inactivePorDeals &&
      Array.isArray(this.props.inactivePorDeals) &&
      !!this.props.inactivePorDeals.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  render() {
    const { loading } = this.props;
    const { data } = this.state;

    return (
      <CarouselRender loading={loading} data={data} title='POR Deals' />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.latestNews.fetching,
  inactivePorDeals: state.inactivePorDeals.data
});

export default connect(mapStateToProps)(InactivePorCarousel);



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/inactive-por-carousel.jsx